export const movies = [
  {
    id: 1,
    title: "流浪地球3",
    titleEn: "The Wandering Earth 3",
    category: "科幻",
    year: 2026,
    rating: 8.7,
    duration: "148分钟",
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健"],
    description: `太阳急速老化，持续膨胀，即将吞噬整个太阳系。为了生存，人类启动「流浪地球」计划，倾全球之力在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，奔向4.2光年外的新家园。在这场前所未有的2500年宇宙之旅中，人类将面对怎样的未知挑战？`,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20futuristic%20space%20adventure%20scene%20with%20astronauts%20and%20massive%20spaceship%20engines%20on%20a%20frozen%20earth%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20clean%20dark%20background%20with%20warm%20orange%20and%20gold%20highlights%2C%20cinematic%20composition&width=600&height=900&seq=movie-poster-01&orientation=portrait",
    featured: true,
    hot: true,
    new: false,
    slug: "liu-lang-di-qiu-3"
  },
  {
    id: 2,
    title: "封神第二部",
    titleEn: "Creation of the Gods II",
    category: "奇幻",
    year: 2026,
    rating: 8.5,
    duration: "156分钟",
    director: "乌尔善",
    cast: ["费翔", "黄渤", "于适"],
    description: "殷商末年，纣王暴虐无道。姜子牙携封神榜下山，辅佐西岐武王伐纣。仙魔大战一触即发，三界众生卷入这场天地浩劫。封神榜上的名字，究竟是谁的宿命？",
    poster: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20ornate%20armor%20with%20magical%20elements%2C%20golden%20and%20crimson%20color%20palette%2C%20dramatic%20composition%2C%20clean%20dark%20background%2C%20cinematic%20lighting&width=600&height=900&seq=movie-poster-02&orientation=portrait",
    featured: true,
    hot: true,
    new: false,
    slug: "feng-shen-di-er-bu"
  },
  {
    id: 3,
    title: "哪吒之魔童闹海",
    titleEn: "Nezha: The Devil Child Rages",
    category: "动画",
    year: 2025,
    rating: 9.2,
    duration: "110分钟",
    director: "饺子",
    cast: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    description: "天劫之后，哪吒与敖丙的灵魂虽得以保留，但肉身危在旦夕。太乙真人打算用七色宝莲为二人重塑肉身，但过程中却遭遇重重困难。与此同时，四海龙王联手来袭，一场关乎陈塘关命运的决战就此展开。",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20style%2C%20mythological%20child%20hero%20with%20flaming%20wheels%20and%20red%20sash%2C%20vibrant%20colors%2C%20dynamic%20action%20pose%2C%20traditional%20Chinese%20art%20style%20blended%20with%20modern%20animation%2C%20clean%20dark%20background&width=600&height=900&seq=movie-poster-03&orientation=portrait",
    featured: true,
    hot: false,
    new: false,
    slug: "ne-zha-zhi-mo-tong-nao-hai"
  },
  {
    id: 4,
    title: "红海行动2",
    titleEn: "Operation Red Sea 2",
    category: "动作",
    year: 2026,
    rating: 8.3,
    duration: "138分钟",
    director: "林超贤",
    cast: ["张译", "黄景瑜", "海清"],
    description: "中国海军蛟龙突击队再次奉命出征，深入战火纷飞的地区执行撤侨任务。面对装备精良的武装分子和重重险境，蛟龙队员以血肉之躯筑起钢铁长城，誓死保卫同胞生命安全。",
    poster: "https://readdy.ai/api/search-image?query=Military%20action%20movie%20poster%2C%20naval%20special%20forces%20soldiers%20in%20tactical%20gear%20during%20combat%20operation%2C%20explosive%20background%20with%20warm%20orange%20fire%2C%20intense%20dramatic%20lighting%2C%20cinematic%20composition%2C%20clean%20dark%20military%20aesthetic&width=600&height=900&seq=movie-poster-04&orientation=portrait",
    featured: false,
    hot: true,
    new: true,
    slug: "hong-hai-xing-dong-2"
  },
  {
    id: 5,
    title: "热辣滚烫",
    titleEn: "YOLO",
    category: "喜剧",
    year: 2024,
    rating: 7.8,
    duration: "129分钟",
    director: "贾玲",
    cast: ["贾玲", "雷佳音", "张小斐"],
    description: "超级废柴女杜乐莹在遭遇亲情、爱情、友情多重打击后，决定换个活法。她开始学习拳击，在汗水中找到自我，最终完成了一次脱胎换骨的蜕变。人生只有一次，必须热辣滚烫！",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20woman%20boxer%20in%20training%20with%20boxing%20gloves%2C%20warm%20optimistic%20vibe%2C%20bright%20lighting%20with%20soft%20shadows%2C%20inspirational%20tone%2C%20clean%20dark%20background%2C%20cinematic%20portrait&width=600&height=900&seq=movie-poster-05&orientation=portrait",
    featured: false,
    hot: false,
    new: false,
    slug: "re-la-gun-tang"
  },
  {
    id: 6,
    title: "飞驰人生2",
    titleEn: "Pegasus 2",
    category: "喜剧",
    year: 2024,
    rating: 8.1,
    duration: "121分钟",
    director: "韩寒",
    cast: ["沈腾", "范丞丞", "尹正"],
    description: "昔日赛车冠军张驰沦落为落魄驾校教练，生活一塌糊涂。某天，濒临停产的老头乐车厂厂长找到他，赞助他组建车队再闯最后一届巴音布鲁克拉力赛。面对强大的对手和种种困难，张驰能否再次点燃心中那团火？",
    poster: "https://readdy.ai/api/search-image?query=Car%20racing%20comedy%20movie%20poster%2C%20rally%20race%20car%20speeding%20on%20mountain%20road%20with%20dust%20trail%2C%20dynamic%20action%20shot%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20wide%20composition%2C%20clean%20minimal%20background&width=600&height=900&seq=movie-poster-06&orientation=portrait",
    featured: false,
    hot: false,
    new: false,
    slug: "fei-chi-ren-sheng-2"
  },
  {
    id: 7,
    title: "第二十条",
    titleEn: "Article 20",
    category: "剧情",
    year: 2024,
    rating: 8.6,
    duration: "143分钟",
    director: "张艺谋",
    cast: ["雷佳音", "马丽", "赵丽颖"],
    description: `人到中年的检察官韩明接手了一起极具争议的案件。案件涉及刑法第二十条「正当防卫」的认定。在法庭内外的激烈交锋中，韩明不仅要面对复杂的法律问题，还要直面自己内心对公平正义的理解与坚守。`,
    poster: "https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%2C%20courtroom%20scene%20with%20judge%20and%20lawyers%2C%20serious%20atmosphere%2C%20warm%20dramatic%20lighting%2C%20cinematic%20composition%2C%20clean%20dark%20background%2C%20professional%20tone&width=600&height=900&seq=movie-poster-07&orientation=portrait",
    featured: false,
    hot: true,
    new: false,
    slug: "di-er-shi-tiao"
  },
  {
    id: 8,
    title: "熊出没·逆转时空",
    titleEn: "Boonie Bears: Time Twist",
    category: "动画",
    year: 2024,
    rating: 7.5,
    duration: "105分钟",
    director: "林汇达",
    cast: ["张伟", "谭笑", "张秉君"],
    description: "光头强在一次意外中穿越到了未来世界，发现狗熊岭已经面目全非。为了回到原来的时间线，光头强与熊大熊二展开了一场跨越时空的奇妙冒险。笑料百出，温情满满！",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%2C%20cartoon%20bear%20characters%20and%20a%20man%20in%20futuristic%20adventure%2C%20colorful%20vibrant%20scene%2C%20playful%20composition%2C%20clean%20bright%20background%2C%20children%20animation%20style&width=600&height=900&seq=movie-poster-08&orientation=portrait",
    featured: false,
    hot: false,
    new: false,
    slug: "xiong-chu-mo-ni-zhuan-shi-kong"
  },
  {
    id: 9,
    title: "草木人间",
    titleEn: "Dwelling by the West Lake",
    category: "剧情",
    year: 2024,
    rating: 7.9,
    duration: "118分钟",
    director: "顾晓刚",
    cast: ["吴磊", "蒋勤勤", "陈建斌"],
    description: "杭州西湖边，刚毕业的大学生目莲为寻找离家多年的父亲，与母亲苔花相依为命。母亲误入传销组织后性情大变，目莲在绝望中踏上了一条寻找自我和救赎母亲的艰难之路。",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20art%20house%20film%20poster%2C%20mother%20and%20son%20by%20west%20lake%20scenery%2C%20contemplative%20mood%2C%20soft%20natural%20lighting%2C%20poetic%20composition%2C%20clean%20minimal%20background%2C%20warm%20earthy%20tones&width=600&height=900&seq=movie-poster-09&orientation=portrait",
    featured: false,
    hot: false,
    new: true,
    slug: "cao-mu-ren-jian"
  },
  {
    id: 10,
    title: "奥本海默",
    titleEn: "Oppenheimer",
    category: "欧美",
    year: 2023,
    rating: 8.8,
    duration: "180分钟",
    director: "克里斯托弗·诺兰",
    cast: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    description: "二战期间，美国物理学家罗伯特·奥本海默被任命为曼哈顿计划负责人，带领顶尖科学家团队研制原子弹。随着原子弹成功爆炸，奥本海默却陷入了对科学、道德和人性的深深反思之中。",
    poster: "https://readdy.ai/api/search-image?query=Historical%20biopic%20movie%20poster%2C%20scientist%20in%20vintage%20suit%20against%20nuclear%20explosion%20background%2C%20dramatic%20black%20and%20white%20with%20warm%20orange%20fire%20highlights%2C%20serious%20expression%2C%20cinematic%20lighting%2C%20clean%20dark%20background&width=600&height=900&seq=movie-poster-10&orientation=portrait",
    featured: true,
    hot: false,
    new: false,
    slug: "ao-ben-hai-mo"
  },
  {
    id: 11,
    title: "蜘蛛侠：纵横宇宙",
    titleEn: "Spider-Man: Across the Spider-Verse",
    category: "欧美",
    year: 2023,
    rating: 8.6,
    duration: "140分钟",
    director: "乔伊姆·多斯·桑托斯",
    cast: ["沙梅克·摩尔", "海莉·斯坦菲尔德", "奥斯卡·伊萨克"],
    description: "迈尔斯·莫拉莱斯再次穿越多元宇宙，与蜘蛛侠联盟一起对抗强大的新威胁。在冒险中，迈尔斯不仅面临着前所未有的危机，还要在保护世界和保护自己所爱之人之间做出艰难抉择。",
    poster: "https://readdy.ai/api/search-image?query=Superhero%20animated%20movie%20poster%2C%20spider%20man%20character%20swinging%20through%20colorful%20futuristic%20city%2C%20vibrant%20comic%20book%20art%20style%2C%20dynamic%20action%20pose%2C%20bold%20colors%2C%20clean%20dark%20background&width=600&height=900&seq=movie-poster-11&orientation=portrait",
    featured: false,
    hot: true,
    new: false,
    slug: "zhi-zhu-xia-zong-heng-yu-zhou"
  },
  {
    id: 12,
    title: "消失的她",
    titleEn: "Lost in the Stars",
    category: "悬疑",
    year: 2023,
    rating: 7.7,
    duration: "122分钟",
    director: "崔睿",
    cast: ["朱一龙", "倪妮", "文咏珊"],
    description: "何非的妻子李木子在海外度假时神秘失踪。就在他几乎绝望之际，一个陌生女人出现在他面前，声称自己就是李木子。所有人都相信这个女人，只有何非认定她是假冒的。真相究竟是什么？",
    poster: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%2C%20mysterious%20woman%20silhouette%20against%20tropical%20ocean%20sunset%2C%20atmospheric%20dark%20mood%2C%20minimal%20composition%2C%20warm%20golden%20light%20with%20dark%20shadows%2C%20clean%20background&width=600&height=900&seq=movie-poster-12&orientation=portrait",
    featured: false,
    hot: false,
    new: false,
    slug: "xiao-shi-de-ta"
  }
];

export const featuredMovies = movies.filter(m => m.featured);
export const hotMovies = movies.filter(m => m.hot);
export const newMovies = movies.filter(m => m.new);
export const getMovieBySlug = (slug: string) => movies.find(m => m.slug === slug);
export const getMoviesByCategory = (category: string) => movies.filter(m => m.category === category);